import { useState } from 'react';

type Props = {
    user?: any;
    onClose: () => void;
    onSave: (data: any) => void;
    onResetPassword?: () => void;
};

export default function UserModal({
                                      user,
                                      onClose,
                                      onSave,
                                      onResetPassword,
                                  }: Props) {

    const [name, setName] =
        useState(user?.name || '');

    const [email, setEmail] =
        useState(user?.email || '');

    const [password, setPassword] =
        useState('');

    const [role, setRole] =
        useState(user?.role || 'editor');

    const handleSubmit = (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        if (user) {

            onSave({
                name,
                email,
                role,
            });

        } else {

            onSave({
                name,
                email,
                password,
                role,
            });

        }
    };

    return (
        <div
            className="modal-overlay"
            onClick={onClose}
        >

            <div
                className="modal-box"
                onClick={(e) => e.stopPropagation()}
            >

                <h2>
                    {user
                        ? 'Edit User'
                        : 'Add User'}
                </h2>

                <form
                    className="modal-form"
                    onSubmit={handleSubmit}
                >

                    <label>
                        Name
                    </label>

                    <input
                        type="text"
                        value={name}
                        onChange={(e) =>
                            setName(
                                e.target.value
                            )
                        }
                        required
                    />

                    <label>
                        Email
                    </label>

                    <input
                        type="email"
                        value={email}
                        onChange={(e) =>
                            setEmail(
                                e.target.value
                            )
                        }
                        required
                    />

                    {!user && (

                        <>
                            <label>
                                Password
                            </label>

                            <input
                                type="password"
                                value={password}
                                onChange={(e) =>
                                    setPassword(
                                        e.target.value
                                    )
                                }
                                placeholder="Enter password"
                                required
                            />
                        </>

                    )}

                    <label>
                        Role
                    </label>

                    <select
                        value={role}
                        onChange={(e) =>
                            setRole(
                                e.target.value
                            )
                        }
                    >
                        <option value="admin">
                            Admin
                        </option>

                        <option value="editor">
                            Editor
                        </option>
                    </select>

                    <div className="modal-actions">

                        <div className="left-actions">

                            <button
                                type="button"
                                className="cancel-btn"
                                onClick={onClose}
                            >
                                Cancel
                            </button>

                        </div>

                        <div className="right-actions">

                            {user && (

                                <button
                                    type="button"
                                    className="reset-btn"
                                    onClick={
                                        onResetPassword
                                    }
                                >
                                    Reset Password
                                </button>

                            )}

                            <button
                                type="submit"
                                className="action-btn"
                            >
                                Save
                            </button>

                        </div>

                    </div>

                </form>

            </div>

        </div>
    );
}
